import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../Config";
import ESSDataTable from "./Components/ESSDataTable";
import ESSSummary from "./Components/ESSSummary";
import SmallPieChart from "./Components/PieChart";
import Collapsible from "react-collapsible";

const ESSDashboard = (props) => {
  const [TopRequiredSkills, setTopRequiredSkills] = useState([]);
  const [SkillsIsOpen, setSkillsIsOpen] = useState(true);
  const [ChartIsOpen, setChartIsOpen] = useState(true);
  const [JobStats, setJobStats] = useState();
  const [ProjectStats, setProjectStats] = useState();
  const [ActivityStats, setActivityStats] = useState();
  const [MyTopSkills, setMyTopSkills] = useState([]);
  const [DateRange, setDateRange] = useState();
  const [TableIsEmpty, setTableIsEmpty] = useState(false);
  const Colors = ["#FFA8A8", "#DE8C8C", "#71D9BB", "#C7A3FF", "#6DA2F2"];
  const [SortIds] = useState([
    "name-up",
    "name-down",
    "location-up",
    "location-down",
    "manager-up",
    "manager-down",
    "similarity-up",
    "similarity-down",
    "applied-up",
    "applied-down",
    "status-up",
    "status-down",
    "application-up",
    "application-down",
  ]);
  const [TableData, setTableData] = useState([]);
  const [TotalElements, setTotalElements] = useState();
  const [SelectedJPAType, setSelectedJPAType] = useState("Vacancies");
  const [StatusEnums] = useState([
    { id: "not-started", enum: "NOT_STARTED" },
    { id: "new", enum: "NEW" },
    { id: "in-progress", enum: "IN_PROGRESS" },
    { id: "accepted", enum: "ACCEPTED" },
    { id: "popular", enum: "POPULAR" },
  ]);

  useEffect(() => {
    fetchTopRequeredSkills();
    fetchJobStats();
    fetchProjectStats();
    fetchActivityStats();
    fetchUserInfo();

    fetchTableData(5, 0, "Vacancies", true);

    // clicks on the bookmark item to transform the indicator to its correct
    // location in case of page refresh or reload.
    setTimeout(() => {
      if (
        window.innerWidth > 450 &&
        document.getElementById("dashboard-bookmark")
      ) {
        // document.getElementById("dashboard-bookmark").click();
      }
    }, 1000);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const fetchTopRequeredSkills = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/user/dashboard/top-required-skill",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // Creating the data for pie chart
        let ChartData = [];
        Res.data.map((Item, index) => {
          ChartData.push({
            name: Item.skill,
            value: Item.count,
            color: Colors[index],
          });
        });

        setTopRequiredSkills(ChartData);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const fetchJobStats = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/statistic/employee",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setJobStats(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchProjectStats = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/statistic/employee",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setProjectStats(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchActivityStats = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/statistic/employee",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setActivityStats(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchUserInfo = () => {
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/user-info",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setMyTopSkills(Res.data.skills);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchTableData = (
    Size,
    Start,
    JPAType,
    IsInitial,
    Criteria,
    DateObj
  ) => {
    // Defining the request data
    let Data = {
      start: Start,
      size: Size,
      criteria: {
        minCreatedTime: null,
        maxCreatedTime: null,
      },
      sorts: [
        {
          direction: "ASC",
          fieldName: "similarity",
        },
      ],
    };
    if (Criteria) {
      Data.criteria = Criteria;
    }

    if (DateObj) {
      let MinCreatedTime = DateObj.startTimestap;
      let MaxCreatedTime = DateObj.endTimestamp;
      Data.criteria.maxCreatedTime = MaxCreatedTime;
      Data.criteria.minCreatedTime = MinCreatedTime;

      setDateRange({
        minCreatedTime: MinCreatedTime,
        maxCreatedTime: MaxCreatedTime,
      });
    } else {
      setDateRange(undefined);
    }

    setSelectedJPAType(JPAType);
    // dynamic request URL based on JPA type selected from bar charts
    var ReqURL;
    if (JPAType === "Vacancies") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/statistic/application-status";
    } else if (JPAType === "Projects") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/statistic/application-status";
    } else if (JPAType === "Activities") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/statistic/application-status";
    }

    if (!IsInitial) {
      //handling the selected sort item
      let ActiveSortId;
      SortIds.map((Sort) => {
        if (
          document.getElementById(Sort) &&
          document.getElementById(Sort).classList.contains("active-pointer")
        ) {
          ActiveSortId = Sort;
        } else if (document.getElementById(Sort) === null) {
          ActiveSortId = "jpa-up";
        }
      });
      let IndexToSlice = ActiveSortId.indexOf("-");
      let SortType = ActiveSortId.slice(0, IndexToSlice);
      let SortDirection = ActiveSortId.slice(
        IndexToSlice + 1,
        ActiveSortId.length
      );

      let Sort = {
        direction: switchSortDirection(SortDirection),
        fieldName: switchSortType(SortType),
      };
      Data.sorts[0] = Sort;
    }

    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTableData(Res.data.results);
        setTotalElements(Res.data.totalElements);
        if (Res.data.results.length === 0) {
          setTableIsEmpty(true);
        } else {
          setTableIsEmpty(false);
          if (
            document.getElementById("1-page-btn") &&
            Start === 0 &&
            IsInitial
          ) {
            setTimeout(() => {
              document
                .getElementById("1-page-btn")
                ?.classList.add("active-page");
            }, 500);
          }
        }
        // pagination and summary numbers information
        if (document.getElementById("end") && Res.data.totalElements < Size) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
          document
            .getElementById("next-page")
            .classList.add("page-btn-disabled");
        } else if (
          document.getElementById("end") &&
          Res.data.totalElements > Size
        ) {
          document.getElementById("end").innerHTML = Start + Size;
          document
            .getElementById("next-page")
            .classList.remove("page-btn-disabled");
        }
        if (Res.data.totalElements < Start + Size) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const switchSortDirection = (Direction) => {
    if (Direction === "up") {
      return "ASC";
    } else {
      return "DESC";
    }
  };

  const switchSortType = (Type) => {
    if (Type === "name") {
      return "title";
    } else if (Type === "location") {
      return "workCity";
    } else if (Type === "manager") {
      return "hiringManager";
    } else if (Type === "similarity") {
      return "similarity";
    } else if (Type === "applied") {
      return "applied";
    } else if (Type === "status") {
      return "currentStage";
    } else if (Type === "application") {
      return "otherApplied";
    }
  };

  const toggleExport = () => {
    let ReqURL;
    if (SelectedJPAType === "Vacancies") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/statistic/application-status/export";
    } else if (SelectedJPAType === "Projects") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/statistic/application-status/export";
    } else if (SelectedJPAType === "Activities") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/statistic/application-status/export";
    }

    let Req = {
      method: "GET",
      baseURL: ReqURL,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };

    let FileName = SelectedJPAType + "_Application_Status_" + ".xlsx";

    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute("download", FileName);
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <>
      <div className="dashboard-pages-content">
        {JobStats && ProjectStats && ActivityStats ? (
          <ESSSummary
            AllApplicationsCount={
              JobStats.allApplications +
              ProjectStats.allApplications +
              ActivityStats.allApplications
            }
            LangData={props.LangData}
            Review={
              JobStats.reviewStage +
              ProjectStats.reviewStage +
              ActivityStats.reviewStage
            }
            Interview={
              JobStats.interviewStage +
              ProjectStats.interviewStage +
              ActivityStats.interviewStage
            }
            FinalDecision={
              JobStats.finalDecision +
              ProjectStats.finalDecision +
              ActivityStats.finalDecision
            }
          />
        ) : null}
        <div className="flex-row">
          <>
            {window.innerWidth <= 450 ? (
              <section
                className={
                  SkillsIsOpen
                    ? "my-skills-wrapper skills-is-open"
                    : "my-skills-wrapper"
                }
              >
                <Collapsible
                  onOpening={() => setSkillsIsOpen(true)}
                  open
                  onClose={() => setSkillsIsOpen(false)}
                  transitionTime={200}
                  trigger={
                    <div className="trigger">
                      <h1 className="section-name">
                        {translateText("your_top_5_skills")}
                      </h1>
                      <i
                        className={
                          SkillsIsOpen
                            ? "feather-chevron-down i-rotated"
                            : "feather-chevron-down"
                        }
                      ></i>
                    </div>
                  }
                >
                  <>
                    {MyTopSkills ? (
                      <section className="chips-wrapper">
                        {MyTopSkills.map((skill) => (
                          <p>{skill.title}</p>
                        ))}
                      </section>
                    ) : null}
                  </>
                </Collapsible>
              </section>
            ) : (
              <section className="my-skills-wrapper">
                <h1 className="section-name">
                  {translateText("your_top_5_skills")}
                </h1>
                <>
                  {MyTopSkills ? (
                    <section className="chips-wrapper">
                      {MyTopSkills.map((skill) => (
                        <p>{skill.title}</p>
                      ))}
                    </section>
                  ) : null}
                </>
              </section>
            )}
          </>
          {window.innerWidth <= 450 ? (
            <Collapsible
              onOpening={() => setChartIsOpen(true)}
              onClose={() => setChartIsOpen(false)}
              open
              transitionTime={200}
              trigger={
                <div
                  className={
                    ChartIsOpen
                      ? "chart-trigger chart-trigger-is-open"
                      : "chart-trigger"
                  }
                >
                  <h1 className="section-name">
                    {translateText("top_5_required_skills")}
                  </h1>
                  <i
                    className={
                      ChartIsOpen
                        ? "feather-chevron-down i-rotated"
                        : "feather-chevron-down"
                    }
                  ></i>
                </div>
              }
            >
              <div className="chart-wrapper">
                <div className="chart-holder">
                  <div className="labels-holder">
                    {TopRequiredSkills.map((Item) => (
                      <div className="skill-label">
                        <span
                          className="skill-circle"
                          style={{ backgroundColor: Item.color }}
                        ></span>
                        <p>{Item.name}</p>
                      </div>
                    ))}
                  </div>
                  <SmallPieChart Data={TopRequiredSkills} />
                </div>
              </div>
            </Collapsible>
          ) : (
            <section className="chart-wrapper">
              <h1 className="section-name">
                {translateText("top_5_required_skills")}
              </h1>
              <div className="chart-holder">
                <div className="labels-holder">
                  {TopRequiredSkills.map((Item) => (
                    <div className="skill-label">
                      <span
                        className="skill-circle"
                        style={{ backgroundColor: Item.color }}
                      ></span>
                      <p>{Item.name}</p>
                    </div>
                  ))}
                </div>
                <SmallPieChart Data={TopRequiredSkills} />
              </div>
            </section>
          )}
        </div>
        <div className="table-wrapper">
          <ESSDataTable
            LangData={props.LangData}
            SelectedJPAType={SelectedJPAType}
            Data={TableData}
            TableIsEmpty={TableIsEmpty}
            FetchData={(Size, Start, JPAType, IsInitial, Criteria, DateRange) =>
              fetchTableData(
                Size,
                Start,
                JPAType,
                IsInitial,
                Criteria,
                DateRange
              )
            }
            TotalElements={TotalElements}
            StatusEnums={StatusEnums}
            SortIds={SortIds}
            ToggleExport={() => toggleExport()}
            SetTableIsEmpty={(Bool) => setTableIsEmpty(Bool)}
            StatusIsActive={false}
          />
        </div>
      </div>
    </>
  );
};

export default ESSDashboard;
